const EMPLOYEE_DOCUMENT_NUMBER_REGEX = /^\d{7,8}-[\dk]/i
const ASSET_PATENT_REGEX = /^(?:[A-Z]{4}-?\d{2}|[A-Z]{2}-?\d{4})/

const getBasename = (filename = '') => {
  const normalized = String(filename)
  const lastDotIndex = normalized.lastIndexOf('.')
  return lastDotIndex >= 0 ? normalized.slice(0, lastDotIndex) : normalized
}

const validators = {
  employee: {
    test: (filename) => EMPLOYEE_DOCUMENT_NUMBER_REGEX.test(getBasename(filename)),
    reason: (filename) => `El archivo ${filename} no contiene un RUT valido al inicio. Formato esperado: 12345678-9.`
  },
  asset: {
    test: (filename) => ASSET_PATENT_REGEX.test(getBasename(filename)),
    reason: (filename) => `El archivo ${filename} no contiene una patente valida al inicio. Formatos esperados: ABCD12, ABCD-12, AB1234 o AB-1234.`
  },
  asset_v2: {
    test: (filename) => getBasename(filename).trim().length > 0,
    reason: (filename) => `El archivo ${filename} no deja un identificador utilizable al quitar la extension.`
  }
}

export const validateMassiveImportFileName = (file, validationType) => {
  const validator = validators[validationType]
  if (!validator) return null

  const filename = String(file?.filename || file?.name || '')
  if (!validator.test(filename)) {
    return validator.reason(filename)
  }

  return null
}

export const getMassiveImportFilesValidationSummary = (files = [], validationType) => {
  const invalidFiles = files
    .map((file, index) => ({
      index,
      filename: file?.filename || file?.name || '',
      reason: validateMassiveImportFileName(file, validationType)
    }))
    .filter((item) => item.reason)

  const totalFiles = files.length
  const invalidCount = invalidFiles.length

  let status = 'valid'
  if (invalidCount > 0 && invalidCount < totalFiles) status = 'warning'
  if (invalidCount > 0 && invalidCount === totalFiles) status = 'error'

  return {
    status,
    invalidFiles,
    invalidCount,
    totalFiles
  }
}

export const getValidMassiveImportFiles = (files = [], validationType) =>
  files.filter((file) => !validateMassiveImportFileName(file, validationType))
